<template>
  <div>
    <div class="bg">
      <Nav @getTime="getTime" title="客流分布"/>
      <div class="distribution-buttons-container">
        <div style="display: flex;justify-content: left">
          <button
              class="distribution-btn"
              :class="{ 'active': activeType === 'visit' }"
              @click="handleClick('visit')"
          >
            <span>到访分布热力图</span>
          </button>
          <button
              class="distribution-btn"
              :class="{ 'active': activeType === 'visitIndex' }"
              @click="handleClick('visitIndex')"
          >
            <span>来源分布热力图</span>
          </button>
          <button
              class="distribution-btn"
              :class="{ 'active': activeType === 'administrative' }"
              @click="handleClick('administrative')"
          >
            <span>来源分布行政图</span>
          </button>
        </div>
        <div class="">
          <div>
            <el-select @change="changePlace" v-model="selectedItem" :value-key="'id'" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.label"
                  :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div :style="{display:activeType === 'visit' ? 'block' : 'none' }" id="container"
           style="width: 100%; margin: 10px 0; position: relative; flex: 1">
        <!-- 可折叠侧边栏 -->
        <div
            class="map-sidebar"
            :style="{ width: getSidebarWidth() }"
        >
          <!-- 折叠按钮（始终显示） -->
          <el-button
              @click="toggleCollapse"
              :icon="getCollapseIcon()"
              circle
              size="small"
              class="collapse-btn"
          />
          <!-- 侧边栏内容（折叠时隐藏） -->
          <div class="sidebar-content" v-show="!isCollapsed">
            <div style="display: flex;justify-content: space-between;width: 50%;margin: 0 auto;color: white">
              <div :class="{isBlack: isType===1 }" class="backGround-line" @click="isType=1">商场到访</div>
              <div :class="{isBlack: isType===2 }" class="backGround-line" @click="isType= 2">商圈到访</div>
            </div>
            <div style="display: flex;flex-direction: column;flex: 1">
              <div v-if="isType===1" style="width: 100%;;border-radius: 12px;">
                <data-table style="background-color: transparent !important;-webkit-box-shadow:none;height: 100%"
                            :min-scroll-rows="10" :roll="true" :data="dataBase" :columns="dataCol"/>
              </div>
              <div v-if="isType===2" style="width: 100%;border-radius: 12px;">
                <data-table style="background-color: transparent !important;-webkit-box-shadow:none;height: 100%"
                            :min-scroll-rows="10" :roll="true" :data="comercialDistrictBase"
                            :columns="comercialDistrictBaseCol"/>
              </div>

              <div style="display: flex;justify-content: space-between;align-items: center;flex: 1">
                <div style="width: 33%;height: 100%">
                  <div class="backGround-line">新旧游客占比</div>
                  <div id="newOldRate" style="width: 200px;height: 150px"></div>
                </div>
                <div style="width: 33%;height: 100%">
                  <div class="backGround-line">游客平均停留时长</div>
                  <div style="font-size: 24px;text-align: center;color: white;height: 70%;display: flex;justify-content: center;align-items: center">{{ stayTime }}天</div>
                </div>
                <div style="width: 33%;height: 100%">
                  <div class="backGround-line">停留天数占比</div>
                  <div id="stayTimeRate" style="width: 200px;height: 150px"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :style="{display:activeType === 'visitIndex' ? 'block' : 'none'}" id="container2"
           style="width: 100%; margin: 10px 0; position: relative; flex: 1">
        <div
            class="map-sidebar"
            style="height: 70% !important;"
            :style="{ width: getSidebarWidth() }"
        >
          <!-- 折叠按钮（始终显示） -->
          <el-button
              @click="toggleCollapse"
              :icon="getCollapseIcon()"
              circle
              size="small"
              class="collapse-btn"
          />
          <!-- 侧边栏内容（折叠时隐藏） -->
          <div class="sidebar-content" v-show="!isCollapsed" style="">
            <div class="backGround-line">
              <div>POI信息点</div>
            </div>
            <div style="display: flex;flex-direction: column;flex: 1">
              <div style="width: 100%;;border-radius: 12px;">
                <data-table style="background-color: transparent !important;-webkit-box-shadow:none;height: 100%"
                            :min-scroll-rows="10" :roll="true" :data="getSourcePoiRankData"
                            :columns="getSourcePoiRankCol"/>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div :style="{display:activeType === 'administrative' ? 'block' : 'none' }" style="flex: 1">
        <div
            style="background-color:rgba(15, 19, 37, 0.8);width: 100%;height: 100%;display: flex;justify-content:space-between">
          <div style="width: 50%;height: 100%" id="container3"></div>
          <div style="width: 50%;display: flex;justify-content: space-between;height: 100%;overflow-y: hidden">
            <div style="width: 45%;height: 100%">
              <el-table
                  :data="sourceProvinceData"
                  height="100%"
                  style="width: 100%;">
                <el-table-column
                    prop="name"
                    label="省份"
                >
                </el-table-column>
                <el-table-column
                    prop="rank"
                    label="排名"
                >
                </el-table-column>
                <el-table-column
                    prop="percentage"
                    label="占比">
                </el-table-column>
              </el-table>
            </div>
            <div style="width: 54%;height: 100%;display: flex;flex-direction: column">
              <el-table
                  :data="sourceCityData"
                  height="50%"
                  style="width: 100%;height: 50%">
                <el-table-column
                    fixed
                    prop="name"
                    label="城市"
                >
                </el-table-column>
                <el-table-column
                    prop="rank"
                    label="排名"
                >
                </el-table-column>
                <el-table-column
                    prop="percentage"
                    label="占比">
                </el-table-column>
              </el-table>
              <el-table
                  :data="sourceAreaData"
                  height="50%"
                  style="width: 100%;height: 50%">
                <el-table-column
                    prop="name"
                    label="区县"
                >
                </el-table-column>
                <el-table-column
                    prop="rank"
                    label="排名"
                >
                </el-table-column>
                <el-table-column
                    prop="percentage"
                    label="占比">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "_c/Nav/Nav.vue";
import AMapLoader from '@amap/amap-jsapi-loader';
import dataTable from "_c/dataTable/dataTable.vue";
import {
  getPoiList, touristsDistributionGetVisitDistribution,
  touristsDistributionGetSourceRate,
  touristsDistributionGetSourceHeatMap,
  touristsDistributionGetSourcePoiRank,
  touristsDistributionGetTouristFlowDayHeat
} from '@/request/passengerFLowDistribution/passengerFLowDistribution'
import * as echarts from "echarts";

export default {
  components: {Nav, dataTable},
  data() {
    return {
      location:{},
      activeType: 'visit', // 默认选中到访分布热力图
      isCollapsed: true,
      selectedItem: null, // 双向绑定select
      sidebarWidth: '30%', // 展开宽度
      collapsedWidth: '40px', // 折叠宽度
      isType: 1, // 选择商城和商圈的切换栏
      options: [], // 存储景点数据
      stayTime: "", // 停留时间
      chart_1: null, // 新旧游客占比
      chart_2: null, // 停留天数占比
      // 存参数
      form: {},
      dataCol: [{label: '排名', prop: 'id'}, {label: '商场名称', prop: 'shopping_mall'}, {
        label: '热度',
        prop: 'percentage',
        type: 'satisfaction'
      }],
      comercialDistrictBaseCol: [{label: '排名', prop: 'id'}, {
        label: '商场名称',
        prop: 'comercial_district'
      }, {label: '热度', prop: 'percentage', type: 'satisfaction'}],
      dataBase: [], // 商城
      comercialDistrictBase: [],// 商圈
      sourceProvinceCol: [{label: '排名', prop: 'rank'}, {label: '省份', prop: 'name'}, {
        label: '占比',
        prop: 'percentage',
        type: 'satisfaction'
      }],
      getSourcePoiRankData: [],  //来源地POI排行
      getSourcePoiRankCol: [{label: '排名', prop: 'rank'}, {label: '来源地', prop: 'attraction_name'}, {
        label: '数量',
        prop: 'count'
      }], // 来源地POI排行格式
      sourceProvinceData: [],  // 省份数据
      sourceCityCol: [{label: '排名', prop: 'rank'}, {label: '城市', prop: 'name'}, {
        label: '占比',
        prop: 'percentage',
        type: 'satisfaction'
      }],
      sourceCityData: [], // 城市数据
      sourceAreaCol: [{label: '排名', prop: 'rank'}, {label: '区县', prop: 'name'}, {
        label: '占比',
        prop: 'percentage',
        type: 'satisfaction'
      }],
      sourceAreaData: [], // 区县数据
    }
  },
  mounted() {
    this.$nextTick(async () => {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await AMapLoader.load({
        key: 'ef49373644dc51e28ef64fae992c51cf',
        version: '2.0',
        plugins: ["AMap.Geocoder", "AMap.HeatMap", 'AMap.Scale', 'AMap.ToolBar', 'AMap.HawkEye', 'AMap.MapType', 'AMap.Geolocation']
      }).then((AMap) => {
        this.map = new AMap.Map('container', {
          zoom: 4.5,
          // viewMode:'3D', //开启3D视图,默认为关闭
          // pitch: 50,
          // rotation: -15,
          // mapStyle: "amap://styles/dark",
          center: [116.333926, 39.997245]
        });
        this.Marker = new AMap.Marker()
        this.geocoder = new AMap.Geocoder({
          city: "全国",
        });

        this.map.addControl(new AMap.Scale())
        this.map.addControl(new AMap.ToolBar())
        this.map.addControl(new AMap.HawkEye())
        this.map.addControl(new AMap.MapType())
        this.map.addControl(new AMap.Geolocation())
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        loading.close();
        this.chart_1 = echarts.init(document.getElementById('newOldRate'));
        this.chart_2 = echarts.init(document.getElementById('stayTimeRate'));
      })
    })
    this.$nextTick(async () => {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await AMapLoader.load({
        key: 'ef49373644dc51e28ef64fae992c51cf',
        version: '2.0',
        plugins: ["AMap.Geocoder", "AMap.HeatMap", 'AMap.Scale', 'AMap.ToolBar', 'AMap.HawkEye', 'AMap.MapType', 'AMap.Geolocation']
      }).then((AMap) => {
        this.map1 = new AMap.Map('container2', {
          zoom: 4.5,
          // viewMode:'3D', //开启3D视图,默认为关闭
          // pitch: 50,
          // rotation: -15,
          // mapStyle: "amap://styles/dark",
          center: [116.333926, 39.997245]
        });
        this.Marker1 = new AMap.Marker()
        this.geocoder1 = new AMap.Geocoder({
          city: "全国",
        });

        this.map1.addControl(new AMap.Scale())
        this.map1.addControl(new AMap.ToolBar())
        this.map1.addControl(new AMap.HawkEye())
        this.map1.addControl(new AMap.MapType())
        this.map1.addControl(new AMap.Geolocation())
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        loading.close();
      })


    })
    this.$nextTick(async () => {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await AMapLoader.load({
        key: 'ef49373644dc51e28ef64fae992c51cf',
        version: '2.0',
        plugins: ["AMap.Geocoder", "AMap.HeatMap", 'AMap.Scale', 'AMap.ToolBar', 'AMap.HawkEye', 'AMap.MapType', 'AMap.Geolocation']
      }).then((AMap) => {
        this.map2 = new AMap.Map('container3', {
          zoom: 4.5,
          // viewMode:'3D', //开启3D视图,默认为关闭
          // pitch: 50,
          // rotation: -15,
          // mapStyle: "amap://styles/dark",
          center: [116.333926, 35.997245]
        });
        this.Marker2 = new AMap.Marker()
        this.geocoder2 = new AMap.Geocoder({
          city: "全国",
        });

        this.map2.addControl(new AMap.Scale())
        this.map2.addControl(new AMap.ToolBar())
        this.map2.addControl(new AMap.HawkEye())
        this.map2.addControl(new AMap.MapType())
        this.map2.addControl(new AMap.Geolocation())
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        loading.close();
      })


    })
  },
  methods: {
    // 选择景点后触发图表参数
    async changePlace(value) {
      console.log(value)
      this.location.lng = value.lng;
      this.location.lat = value.lat;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.form.poiId = value.id
      if (this.activeType === 'visit') {
        // 图表数据
        await touristsDistributionGetVisitDistribution(this.form).then(res => {
          this.dataBase = res.data.data.shoppingMall
          for (let i = 0; i < this.dataBase.length; i++) {
            this.dataBase[i].id = i + 1
          }
          this.comercialDistrictBase = res.data.data.comercialDistrict
          this.stayTime = res.data.data.stayTime
          for (let i = 0; i < this.comercialDistrictBase.length; i++) {
            this.comercialDistrictBase[i].id = i + 1
          }
          let data = res.data.data.newOldRate.map(item => ({
            value: item.count,
            name: item.name,
          }))
          let data1 = res.data.data.stayTimeRate.map(item => ({
            value: item.count,
            name: item.tour_days,
          }))
          var color = [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ];
          this.chart_1.setOption({
            //你的代码
            backgroundColor: "transparent",
            color: color,
            tooltip: {
              show: true,
              backgroundColor: 'rgba(13,5,30,.6)',
              borderWidth: 1,
              borderColor: '#32A1FF',
              padding: 5,
              textStyle: {
                color: '#fff'
              },
              confine: true,
              formatter(params) {
                if (params.name === '') {
                  return '';
                }
                return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
              },
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['30%', '60%'],
                center: ['50%', '55%'], // 修改为居中
                avoidLabelOverlap: true,
                label: {
                  color: '#fff',
                  alignTo: 'labelLine',
                  formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                  minMargin: 5,
                  edgeDistance: 5,
                  lineHeight: 5,
                  rich: {
                    num: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    },
                    zb: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    }
                  }
                },
                labelLine: {
                  length: 5,
                  length2: 5,
                  maxSurfaceAngle: 80
                },
                data: data
              }
            ]
          })
          this.chart_2.setOption({
            //你的代码
            backgroundColor: "transparent",
            color: color,
            tooltip: {
              show: true,
              backgroundColor: 'rgba(13,5,30,.6)',
              borderWidth: 1,
              borderColor: '#32A1FF',
              padding: 5,
              textStyle: {
                color: '#fff'
              },
              confine: true,
              formatter(params) {
                if (params.name === '') {
                  return '';
                }
                return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
              },
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['30%', '60%'],
                center: ['50%', '55%'], // 修改为居中
                avoidLabelOverlap: true,
                label: {
                  color: '#fff',
                  alignTo: 'labelLine',
                  formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                  minMargin: 5,
                  edgeDistance: 5,
                  lineHeight: 5,
                  rich: {
                    num: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    },
                    zb: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    }
                  }
                },
                labelLine: {
                  length: 5,
                  length2: 5,
                  maxSurfaceAngle: 80
                },
                data: data1
              }
            ]
          })
        })
        // 热力图数据
        await touristsDistributionGetTouristFlowDayHeat(this.form).then(res => {
          const heatmapData = res.data.data.heatData
          if (this.heatMap) {
            this.heatMap.setMap(null); // 先解除与地图的关联
            this.heatMap = null; // 释放引用
          }

          this.heatMap = new window.AMap.HeatMap(this.map, {
            radius: 40,
            opacity: [0, 0.8]
          });

          this.map.setCenter([this.location.lng, this.location.lat]);
          this.map.setZoom(15);

          // 6. 设置新的热力图数据
          this.map.getAllOverlays('heatmap').forEach(overlay => {
            this.map.remove(overlay);
          });
          this.heatMap.setDataSet({
            data: heatmapData,
            max: 100
          });
        })

      }
      // 当前页面是来源分布热力图时，才会加载对应数据
      if (this.activeType === 'visitIndex') {
        // 来源分布热力图
        await touristsDistributionGetSourceHeatMap(this.form).then(res => {
          const heatmapData = res.data.data
          if (this.heatMap1) {
            this.heatMap1.setMap(null); // 先解除与地图的关联
            this.heatMap1 = null; // 释放引用
          }

          this.heatMap1 = new window.AMap.HeatMap(this.map1, {
            radius: 40,
            opacity: [0, 0.8]
          });
          this.map1.getAllOverlays('heatmap').forEach(overlay => {
            this.map1.remove(overlay);
          });
          this.heatMap1.setDataSet({
            data: heatmapData,
            max: 100
          });
        })
        await touristsDistributionGetSourcePoiRank(this.form).then(res => {
          this.getSourcePoiRankData = res.data.data
        })
      }
      if (this.activeType === 'administrative') {
        //  来源地排名
        await touristsDistributionGetSourceRate(this.form).then(res => {
          this.sourceProvinceData = res.data.data.sourceProvince
          this.sourceCityData = res.data.data.sourceCity
          this.sourceAreaData = res.data.data.sourceArea
        })
        // 来源分布行政图热力图
        await touristsDistributionGetSourceHeatMap(this.form).then(res => {
          const heatmapData = res.data.data
          if (this.heatMap2) {
            this.heatMap2.setMap(null); // 先解除与地图的关联
            this.heatMap2 = null; // 释放引用
          }

          this.heatMap2 = new window.AMap.HeatMap(this.map2, {
            radius: 40,
            opacity: [0, 0.8]
          });
          this.map2.getAllOverlays('heatmap').forEach(overlay => {
            this.map2.remove(overlay);
          });
          this.heatMap2.setDataSet({
            data: heatmapData,
            max: 100
          });
        })

      }
      loading.close();
    },
    async getTime(value) {
      // 你的时间处理逻辑
      this.form.startTime = value[0]
      this.form.endTime = value[1]
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.activeType === 'visit') {
        try {
          //  热力图数据
          await touristsDistributionGetTouristFlowDayHeat(this.form).then(res => {
            const heatmapData = res.data.data.heatData
            if (this.heatMap) {
              this.heatMap.setMap(null); // 先解除与地图的关联
              this.heatMap = null; // 释放引用
            }
            this.heatMap = new window.AMap.HeatMap(this.map, {
              radius: 40,
              opacity: [0, 0.8]
            });
            // 3. 重新设置地图中心
            this.map.setCenter([this.location.lng, this.location.lat]);
            this.map.setZoom(15);
            // 6. 设置新的热力图数据
            this.map.getAllOverlays('heatmap').forEach(overlay => {
              this.map.remove(overlay);
            });
            this.heatMap.setDataSet({
              data: heatmapData,
              max: 100
            });
          })
        } finally {
          // 图表数据
          await touristsDistributionGetVisitDistribution(this.form).then(res => {
            this.dataBase = res.data.data.shoppingMall
            for (let i = 0; i < this.dataBase.length; i++) {
              this.dataBase[i].id = i + 1
            }
            this.comercialDistrictBase = res.data.data.comercialDistrict
            this.stayTime = res.data.data.stayTime
            for (let i = 0; i < this.comercialDistrictBase.length; i++) {
              this.comercialDistrictBase[i].id = i + 1
            }
            let data = res.data.data.newOldRate.map(item => ({
              value: item.count,
              name: item.name,
            }))
            let data1 = res.data.data.stayTimeRate.map(item => ({
              value: item.count,
              name: item.tour_days,
            }))
            var color = [
              "#FF5733",
              "#33FF57",
              "#3357FF",
              "#FF33A1",
              "#9033FF",
              "#33FFF6",
              "#FFBD33",
              "#FF3333",
              "#FFFFFF"
            ];
            this.chart_1.setOption({
              //你的代码
              backgroundColor: "transparent",
              color: color,
              tooltip: {
                show: true,
                backgroundColor: 'rgba(13,5,30,.6)',
                borderWidth: 1,
                borderColor: '#32A1FF',
                padding: 5,
                textStyle: {
                  color: '#fff'
                },
                confine: true,
                formatter(params) {
                  if (params.name === '') {
                    return '';
                  }
                  return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
                },
              },
              series: [
                {
                  name: '',
                  type: 'pie',
                  radius: ['30%', '60%'],
                  center: ['50%', '55%'], // 修改为居中
                  avoidLabelOverlap: true,
                  label: {
                    color: '#fff',
                    alignTo: 'labelLine',
                    formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                    minMargin: 5,
                    edgeDistance: 5,
                    lineHeight: 5,
                    rich: {
                      num: {
                        fontSize: 14,
                        color: '#FFFFFF'
                      },
                      zb: {
                        fontSize: 14,
                        color: '#FFFFFF'
                      }
                    }
                  },
                  labelLine: {
                    length: 5,
                    length2: 5,
                    maxSurfaceAngle: 80
                  },
                  data: data
                }
              ]
            })
            this.chart_2.setOption({
              //你的代码
              backgroundColor: "transparent",
              color: color,
              tooltip: {
                show: true,
                backgroundColor: 'rgba(13,5,30,.6)',
                borderWidth: 1,
                borderColor: '#32A1FF',
                padding: 5,
                textStyle: {
                  color: '#fff'
                },
                confine: true,
                formatter(params) {
                  if (params.name === '') {
                    return '';
                  }
                  return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
                },
              },
              series: [
                {
                  name: '',
                  type: 'pie',
                  radius: ['30%', '60%'],
                  center: ['50%', '55%'], // 修改为居中
                  avoidLabelOverlap: true,
                  label: {
                    color: '#fff',
                    alignTo: 'labelLine',
                    formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                    minMargin: 5,
                    edgeDistance: 5,
                    lineHeight: 5,
                    rich: {
                      num: {
                        fontSize: 14,
                        color: '#FFFFFF'
                      },
                      zb: {
                        fontSize: 14,
                        color: '#FFFFFF'
                      }
                    }
                  },
                  labelLine: {
                    length: 5,
                    length2: 5,
                    maxSurfaceAngle: 80
                  },
                  data: data1
                }
              ]
            })
          })
          loading.close()
        }
      }
      if (this.activeType === 'visitIndex') {
        try {
          // 热力图数据
          await touristsDistributionGetSourceHeatMap(this.form).then(res => {
            const heatmapData = res.data.data
            if (this.heatMap) {
              this.heatMap.setMap(null); // 先解除与地图的关联
              this.heatMap = null; // 释放引用
            }

            this.heatMap = new window.AMap.HeatMap(this.map, {
              radius: 40,
              opacity: [0, 0.8]
            });



            // 6. 设置新的热力图数据
            this.map.getAllOverlays('heatmap').forEach(overlay => {
              this.map.remove(overlay);
            });
            this.heatMap.setDataSet({
              data: heatmapData,
              max: 100
            });

          })
        }finally {
          //  来源地排名
          await touristsDistributionGetSourcePoiRank(this.form).then(res => {
            this.getSourcePoiRankData = res.data.data
          })
          loading.close()
        }
      }
      if (this.activeType === 'administrative') {

        // 来源分布行政图热力图
        await touristsDistributionGetSourceHeatMap(this.form).then(res => {
          try {
            const heatmapData = res.data.data
            if (this.heatMap2) {
              this.heatMap2.setMap(null); // 先解除与地图的关联
              this.heatMap2 = null; // 释放引用
            }
            this.heatMap2 = new window.AMap.HeatMap(this.map2, {
              radius: 40,
              opacity: [0, 0.8]
            });



            this.map2.getAllOverlays('heatmap').forEach(overlay => {
              this.map2.remove(overlay);
            });
            this.heatMap2.setDataSet({
              data: heatmapData,
              max: 100
            });
          } finally {
            loading.close();
          }
        })
        //  来源地排名
        await touristsDistributionGetSourceRate(this.form).then(res => {
          this.sourceProvinceData = res.data.data.sourceProvince
          this.sourceCityData = res.data.data.sourceCity
          this.sourceAreaData = res.data.data.sourceArea
        })

      }
    },
    // 切换来源分布行政图
    handleClick(type) {
      this.activeType = type;
      this.selectedItem = ''
      // 可以在这里触发父组件的事件，传递选中的类型
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    getCollapseIcon() {
      return this.isCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left';
    },
    getSidebarWidth() {
      return this.isCollapsed ? this.collapsedWidth : this.sidebarWidth;
    }
  },
  created() {
    // 获取景点
    getPoiList().then(res => {
      this.options = res.data.data.map(item => ({
        id: item.id,
        value: item.id,
        label: item.name,
        lng: item.lng,
        lat: item.lat,
      }))
    })
  }
}
</script>

<style scoped lang="scss">
* {
  //color: white;
}

.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.map-sidebar {
  position: absolute;
  left: 0;
  top: 5%;
  z-index: 1;
  background-color: rgba(19, 25, 47, 0.9);
  height: 90%;
  border-radius: 0 8px 8px 0;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sidebar-content {
  padding: 15px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
}

.sidebar-body {
  flex: 1;
  overflow-y: auto;
  padding-right: 5px; /* 为滚动条留出空间 */
}

.sidebar-card {
  background-color: rgba(15, 19, 37, 0.6);
  border: none;
  margin-bottom: 10px;
  color: white;

  > > > .el-card__body {
    padding: 15px;

    > div {
      padding: 5px 0;
    }
  }
}

.collapse-btn {
  position: absolute;
  right: 5px;
  top: 5px;
  background-color: rgba(64, 158, 255, 0.3);
  border: none;
  color: white;
  z-index: 2;

  &:hover {
    background-color: rgba(64, 158, 255, 0.7);
  }
}

/* 自定义滚动条 */
.sidebar-body::-webkit-scrollbar {
  width: 5px;
}

.sidebar-body::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.sidebar-body::-webkit-scrollbar-thumb {
  background: rgba(64, 158, 255, 0.5);
  border-radius: 3px;
}

/* 折叠状态下的样式 */
.map-sidebar.collapsed {
  .sidebar-content {
    display: none;
  }

  .collapse-btn {
    position: static;
    margin: 5px auto;
    display: block;
  }
}

.isBlack {
  color: black;
  border: 1px black solid;
}

.container-child {
  position: absolute;
  top: 10%; // 垂直居中
  right: 20%; // 距离右边30px
  //transform: translateY(-50%);  // 精准垂直居中
  z-index: 9; // 确保在地图之上

  .el-select {
    width: 200px; // 增大宽度
    font-size: 16px; // 增大字体
    background-color: #ffffffcc; // 半透明白色背景
    border-radius: 8px; // 圆角
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); // 阴影
    transition: all 0.3s ease;
    margin-left: 10px;

    ::v-deep.el-select .el-input__inner {
      //margin-left: 10px !important;
    }

    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3); // 悬停阴影加强
    }

    .el-input__inner {
      background-color: transparent; // 内部输入框透明
      color: #333; // 深色文字
      border: none; // 移除默认边框
    }

    .el-select-dropdown {
      background-color: #ffffffcc; // 下拉菜单半透明
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .el-select-dropdown__item {
      font-size: 15px;
      padding: 10px 20px;

      &:hover {
        background-color: #e6f7ff; // 悬停颜色
      }
    }
  }
}

:deep(.visual-table-wrapper) {
  height: auto !important;
}

.distribution-buttons-container {
  display: flex;
  gap: 12px;
  padding: 10px 0;
  align-items: center;
  justify-content: space-between; /* 左对齐排列 */
}

.distribution-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: rgba(25, 35, 60, 0.7);
  border: 1px solid rgba(100, 180, 255, 0.2);
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.distribution-btn:hover {
  background-color: rgba(35, 50, 85, 0.9);
  border-color: rgba(100, 180, 255, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.distribution-btn.active {
  background-color: rgba(64, 158, 255, 0.2);
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  font-weight: 500;
}

.distribution-btn i {
  font-size: 16px;
  color: #409eff;
}

.distribution-btn.active i {
  color: #69b1ff;
}

:deep(.el-input__inner) {
  background-color: transparent;
  border: none;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .distribution-buttons-container {
    flex-wrap: wrap;
  }

  .distribution-btn {
    flex: 1;
    min-width: 200px;
    justify-content: center;
  }
}

/* 修改表格背景色 */
:deep(.el-table) {
  background-color: transparent !important; /* 透明背景 */
  color: #fff; /* 文字颜色 */
}

/* 表头背景色 */
:deep(.el-table th) {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

/* 表格行背景色 */
:deep(.el-table tr) {
  background-color: rgba(15, 19, 37, 0.4) !important;
}

/* 鼠标悬停行背景色 */
:deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
  background-color: rgba(64, 158, 255, 0.7) !important;
}

/* 单元格边框色 */
:deep(.el-table td, .el-table th) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* 隐藏 el-table 的滚动条 */
:deep(.el-table__body-wrapper::-webkit-scrollbar) {
  display: none; /* Chrome/Safari */
}

:deep(.el-table__body-wrapper) {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
</style>
